<template>
<q-dialog
  v-model="state.show"
  persistent
>
  <div class="column image-processiong-dialog-body">
    <div class="text-h6">이미지 수정</div>
    <div style="padding:10px 0px 15px 0px">
      <q-btn-group class="image-tool-btn-group" unelevated dense>
        <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" dense no-caps @click="listen__fit__onclick" style="padding:0px 5px;" />
        <q-separator vertical />
        <q-btn unelevated color="primary" icon="history" label="되돌리기" dense no-caps style="padding:0px 5px;" @click="listen__restore__onclick"/>
        <q-separator vertical />
        <q-btn unelevated color="primary" icon="screen_rotation" label="90도 회전" dense no-caps style="padding:0px 5px;" @click="listen__rotation__onclick"/>
        <q-separator vertical />
        <q-btn unelevated color="primary" icon="crop" label="자르기" dense no-caps style="padding:0px 5px;" @click="listen__crop__onclick"/>
      </q-btn-group>
    </div>
    <div v-if="state.mode == 'crop'">
      <span style="color:#555555;"><b>자르기 모드:</b> 이미지에서 마우스 클릭으로 점 4개<i>(좌상단, 우상단, 우하단, 좌하단 순)</i>를 찍어 주세요.</span>
    </div>
    <div class="col full-width" style="border:1px solid rgba(0, 0, 0, 0.2);position:relative">
      <image-view
        ref="image-view"
        :frame-data="frameData"
        class="col full-height full-width"
        :mode="state.mode"
        :tool-options="cropPointInfo"
        @onstatechange="listen__image_view__onstatechange"
        @onadd="listen__image_view__add" />
      <div v-if="state.mode == 'crop' && state.cropPoints.length > 0" style="position:absolute;top:10px;right:10px;background:#FFFFFF99;font-size:12px;border-radius:5px;border:1px solid #00000033;">
        <ul style="margin:0;padding-left:25px;padding-right:5px;padding-top:2px;padding-bottom:2px;">
          <li v-for="(cropPoint, i) in state.cropPoints" :key="`crop-point-${i}`" :style="{color: cropPointInfo.colors[i]}" style="padding:0;margin:0">
            <span style="color:black;margin-left:-5px">{{ cropPointInfo.names[i] + ':' + '[' + cropPoint.join(', ') + ']' }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="state.loadingLayer.show" style="position:absolute;background:#FFFFFFAA;width:100%;height:100%;left:0px;top:0px;z-index:99999;display:flex;flex-direction:column;justify-content:center;align-items:center;">
      <q-spinner-facebook
          color="primary"
          size="2em"
        />
      {{ state.loadingLayer.message }}
    </div>
    <div class="row" style="padding:10px 0px 0px 0px;justify-content:right">
      <q-btn-group class="image-tool-btn-group" unelevated dense>
        <q-btn unelevated color="primary" label="적용" dense no-caps style="padding:0px 5px;" @click="listen__btn_apply__onclick"/>
        <q-separator vertical />
        <q-btn unelevated color="primary" label="취소" dense no-caps style="padding:0px 5px;" @click="listen__btn_cancel__onclick"/>
      </q-btn-group>
    </div>
  </div>
</q-dialog>
</template>

<script>
import MixinLayer from '@/mixins/layer.js'

import ImageView from '@/components/imageprocessingdialog/ImageView.vue'

import PNGJS from 'pngjs'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
// import COMM from '@/js/comm.js'

export default {
  props: [],
  components: {
    ImageView
  },
  mixins: [MixinLayer],
  data: function () {
    return {
      frameData0: null,
      frameData: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      loaded: false,
      state: {
        mode: null,
        show: false,
        cropPoints: []
      },
      cropPointInfo: {
        colors: ['#ee4035', '#f37736', '#7bc043', '#0392cf'],
        names: ['좌상단', '우상단', '우하단', '좌하단']
      }
    }
  },
  methods: {
    listen__fit__onclick: function () {
      const Vue = this
      Vue.state.mode = null
      Vue.$refs['image-view'].fitToWindow()
    },
    listen__restore__onclick: async function () {
      const Vue = this
      Vue.state.mode = null

      if (Vue.frameData0.id == Vue.frameData.id)
        return

      Vue.showLayer('되돌리는 중...')

      Vue.frameData = {
        _empty: true
      }

      await MISC.doubleRaf(async () => {})
      
      Vue.frameData = Vue.frameData0

      Vue.hidingLayer()
    },
    listen__rotation__onclick: async function () {
      const Vue = this
      Vue.state.mode = null
      Vue.showLayer('변환 중...')
      
      MISC.doubleRaf(async () => {
        let cornerstoneImage = await Vue.rotate90(Vue.frameData.cornerstoneImage)
        
        Vue.frameData = {
          id: MISC.getUuid4(),
          name: Vue.frameData0.name,
          cornerstoneImage,
          _empty: false
        }

        await (async () => {})()
        Vue.$refs['image-view'].update()

        Vue.hidingLayer()
      })
    },
    listen__crop__onclick: function () {
      const Vue = this
      if (Vue.state.mode == 'crop') {
        Vue.state.mode = null
      }
      else
        Vue.state.mode = 'crop'
    },
    listen__image_view__onstatechange: function () {
    },
    listen__image_view__add: function (data) {
      const Vue = this
      const x = data.handles.end.x
      const y = data.handles.end.y
      const width = Vue.frameData.cornerstoneImage.width
      const height = Vue.frameData.cornerstoneImage.height
      
      if (x >= 0 && x < width && y >= 0 && y < height) {
        Vue.state.cropPoints.push([parseInt(data.handles.end.x), parseInt(data.handles.end.y)])
      }
    },
    listen__btn_apply__onclick: function () {
      const Vue = this
      Vue.$emit('done', {id: Vue.frameData.id, cornerstoneImage: Vue.frameData.cornerstoneImage})
      Vue.state.mode = 'close'
      Vue.state.show = false
    },
    listen__btn_cancel__onclick: function () {
      const Vue = this
      Vue.state.mode = 'close'
      Vue.state.show = false
    },
    open: function (frameData0) {
      const Vue = this
      Vue.state.show = true
      Vue.frameData0 = frameData0
      Vue.frameData = frameData0
    },
    close: function () {
      const Vue = this
      Vue.state.show = false
    },
    rotate90: async function (cornerstoneImage0) {
      const Vue = this
      
      const pixelData0 = cornerstoneImage0.getPixelData()
      let pixelData = new Uint8Array(pixelData0.length)

      const channels = 4
      const step = cornerstoneImage0.width * channels
      let i = 0
      for (let col = 0; col < cornerstoneImage0.width; col++) {
        const colStep = col * channels
        for (let row = cornerstoneImage0.height - 1; row >= 0; row--) {
          let index = row * step + colStep
          for (let channel = 0; channel < channels; channel++)
            pixelData[i++] = pixelData0[index + channel]
        }
      }

      const cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, pixelData, cornerstoneImage0.height, cornerstoneImage0.width)
      return cornerstoneImage
    },
    comm: async function (base64Bytes, url, kwargs = {}, headers) {
      return new Promise(function (resolve, reject) {
        try {
          fetch(
            url,
            {
              method: 'POST',
              mode: 'cors',
              body: base64Bytes ? JSON.stringify({data: base64Bytes, ...kwargs}) : JSON.stringify({...kwargs}),
              headers: headers ?  headers : {
                'Content-Type': 'application/json'
              },
              timeout: 30
            }
          ).then((response) => {
            return response.json()
          }
          ).then((ret) => {
            if (ret.code) {
              if (ret.code < 0) {
                reject('인식 서버 오류, code: ' + ret.code)
                return
              }
            }
            if (ret.status && ret.status != 0) {
              reject('인식 서버 오류, code: ' + ret.code)
              return
            }
            resolve(ret)
          }).catch(error => reject(error + ''));
        } catch (e) {
          reject('timeout')
        }
      })
    },
    cropImpl: async function (cornerstoneImage, cropPoints) {
      const Vue = this
      const pixelData = cornerstoneImage.getPixelData()
      let png = new PNGJS.PNG({width: cornerstoneImage.width, height: cornerstoneImage.height})
      for (let row = 0; row < cornerstoneImage.height; row++) {
        for (let col = 0; col < cornerstoneImage.width; col++) {
          const idx = (cornerstoneImage.width * row + col) << 2
          
          png.data[idx] = pixelData[idx]
          png.data[idx + 1] = pixelData[idx + 1]
          png.data[idx + 2] = pixelData[idx + 2]
          png.data[idx + 3] = pixelData[idx + 3]
        }
      }

      const encoded = PNGJS.PNG.sync.write(png)
      // const b64data = await COMM.toBase64(new Blob(encoded))
      const b64data = MISC.convertBufferToBase64(encoded)

      let ret = null
      try {
        // ret = await Vue.comm(b64data, `https://127.0.0.1/api/image/process/crop`, {cropPoints})
        ret = await Vue.comm(b64data, `${process.env.VUE_APP_URL}/api/image/process/crop`, {cropPoints})
      } catch (err) {
        console.log(err)
        throw err
      }

      if (ret != null) {
        const image = await PARSE.parsePng(MISC.convertBase64ToBuffer(ret.image))
        const cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height)
        return cornerstoneImage
      } else
        return null
    }
  },
  watch: {
    'state.mode': function (newVal, oldVal) {
      const Vue = this
      if (oldVal == 'crop' && newVal != 'close') {
        Vue.$q.notify({
          message: '자르기 취소',
          icon: 'announcement',
          color: 'black'
        })
        Vue.state.cropPoints = []
      }
    },
    'state.cropPoints': async function (cropPoints) {
      const Vue = this
      if (cropPoints.length == 4) {
        Vue.showLayer('변환 중...')
        MISC.doubleRaf(async () => {
          let ret = null
          try {
            ret = await Vue.cropImpl(Vue.frameData.cornerstoneImage, cropPoints)
          } catch (err) {
            console.log(err)
            Vue.$q.notify({
              message: err,
              icon: 'announcement',
              color: 'red'
            })
          }

          Vue.state.cropPoints = []
          Vue.$refs['image-view'].clearToolState('Crop')
          if (ret != null) {
            Vue.frameData = {
              _empty: true
            }

            await (async () => {})()
            
            Vue.frameData = {
              id: MISC.getUuid4(),
              name: Vue.frameData0.name,
              cornerstoneImage: ret,
              _empty: false
            }

            await (async () => {})()

            Vue.$refs['image-view'].setCropMode()
          }
          Vue.hidingLayer()
        })
      }
    }
  }
}

</script>

<style scoped>
.image-processiong-dialog-body {
  background:rgb(237, 238, 242);
  padding:15px 20px;
  max-width:none;
  position:relative;
  width:85%;
  height:85%;
}
</style>